import firebase from 'firebase';
import { db, storage } from './firebase';
import { firestoreKeys } from '../utils/constants';

// ----------------------------------------------------------------------

export default function useJobsService() {
  const createJobOffering = () =>
    db.collection(firestoreKeys.JOBS).add({
      meta: {
        createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });

  const updateJobOffering = (jobId, data) => db.collection(firestoreKeys.JOBS).doc(jobId).update(data);

  const uploadJobOfferingImage = async (jobId, image) => {
    const filename = `${Date.now()}-${image.name}`;
    const ref = storage.ref(`${firestoreKeys.JOBS}/${jobId}/${filename}`);
    await ref.put(image);
    return ref.getDownloadURL();
  };

  const deleteJobOfferingImage = async (imageUrl) => {
    try {
      const imageRef = storage.refFromURL(imageUrl);
      await imageRef.delete();
      return true;
    } catch (error) {
      console.error('Error deleting image:', error);
      return false;
    }
  };

  const deleteJobOffering = (jobId) => db.collection(firestoreKeys.JOBS).doc(jobId).delete();

  return { createJobOffering, uploadJobOfferingImage, updateJobOffering, deleteJobOffering, deleteJobOfferingImage };
}
